<template>
    <div @click="itemClickParser" class="color-list-item" :style="{backgroundColor:this.currentColor.rgbString,color:this.$store.state.Color.contrastTextColor(this.currentColor.hsl,'hsl')}" v-if="validColor">{{currentColor[$store.state.colorDisplayMode+'String']}}</div>
</template>
<script type="text/javascript">
    export default{
        props:{
            color:{
                type:Object,
                required:true
            }
        },
        data(){
            return {
                clicks:0,
                timer:null
            };
        },
        methods:{
            changeCurrentColor(){
                this.$store.commit('setCurrentColor', this.currentColor);
            },
            toggleThemeColor(){
                this.$store.commit('toggleCurrentThemeColor', this.currentColor);
            },
            itemClickParser(){
                let that = this;
                that.clicks++;
                if(that.clicks==1){
                    that.timer = setTimeout(function(){
                        that.changeCurrentColor();
                        that.clicks=0;
                    },400)
                }else{
                    clearTimeout(that.timer)
                    that.toggleThemeColor();
                    that.clicks=0;
                }
            }
        },
        computed:{
            currentColor(){
                if(this.color){
                    return this.color;
                }else{
                    return new this.$store.state.Color();
                }
            },
            validColor(){
                return this.color.rgb.every(val=>0<=val && 255>=val);
            }
        }
    }
</script>
<style type="text/css">
    .color-list-item{
        width: 100%;
        padding: 1.2em 0;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
        border-bottom-width: 1px;
        border-color: rgba(0,0,0,0.1);
        border-style: solid;
        position: relative;
    }
    .color-list-item::before,
    .color-list-item::after{
        content:"";
        position: absolute;
        top: calc(50% - 8px);
    }
    .color-list-item::after{
        left:0;
        transition: border-left,border-top,border-right,border-bottom, 0.15s ease-in-out;
        border-left: solid 0px #FFF;
        border-top: solid 0px transparent;
        border-bottom: solid 0px transparent;
    }
    .color-list-item:hover::after{
        border-left: solid 10px #FFF;
        border-top: solid 10px transparent;
        border-bottom: solid 10px transparent;
    }
    .color-list-item::before{
        right:0;
        transition: border-left,border-top,border-right,border-bottom, 0.15s ease-in-out;
        border-right: solid 0px #FFF;
        border-top: solid 0px transparent;
        border-bottom: solid 0px transparent;
    }
    .color-list-item:hover::before{
        border-right: solid 10px #FFF;
        border-top: solid 10px transparent;
        border-bottom: solid 10px transparent;
    }
</style>